import { createSelector } from '@reduxjs/toolkit';

import { RootState } from '~/types';

const selectSelf = (state: RootState) => state;

export const selectApp = createSelector(selectSelf, state => state.app);

export const selectFlightOffers = createSelector(selectSelf, state => state.flightSearch);

export const selectUser = createSelector(selectSelf, state => state.user);

export const currencySelector = createSelector(selectApp, app => app.currency);

export const selectItineraryPackages = createSelector(selectSelf, state => state.itineraryPackages);
